

/**
 * Informs the customer that the agent has marked it tax exempt. Right sidebar.
 *
 * @param props
 * @returns {JSX.Element|null}
 * @constructor
 */
export default function TaxExemptIndicator(props) {
  let {shoppingCart} = props;
  let {taxExemptCode} = shoppingCart;

  if (!taxExemptCode)
    return null;

  return <div className="text-center">
    <span className="fa fa-check text-green-400 mx-2"/>
    Tax Exemption No. <b>{taxExemptCode}</b>
  </div>
}
